export const cardTypesMock: number[] = [1, 2, 3, 4];
